import apiService from './api'

/**
 * Authentication service for handling user auth operations
 */
export const authService = {
  /**
   * User registration
   * @param {Object} userData - Registration data
   * @returns {Promise} - API response
   */
  register: async (userData) => {
    return await apiService.post('/register/', userData)
  },

  /**
   * User login
   * @param {string} email - User email
   * @param {string} password - User password
   * @returns {Promise} - API response with user data and tokens
   */
  login: async (email, password) => {
    return await apiService.post('/login/', { email, password })
  },

  /**
   * Confirm account with OTP
   * @param {string} email - User email
   * @param {string} confirmation_code - OTP code
   * @returns {Promise} - API response
   */
  confirmAccount: async (email, confirmation_code) => {
    return await apiService.post('/confirm-account/', {
      email,
      confirmation_code
    })
  },

  /**
   * Resend confirmation code
   * @param {string} email - User email
   * @returns {Promise} - API response
   */
  resendConfirmation: async (email) => {
    return await apiService.post('/resend-confirmation/', { email })
  },

  /**
   * Request password reset
   * @param {string} email - User email
   * @returns {Promise} - API response
   */
  requestPasswordReset: async (email) => {
    return await apiService.post('/password-reset-request/', { email })
  },

  /**
   * Confirm password reset with token
   * @param {string} email - User email
   * @param {string} token - Reset token
   * @param {string} new_password - New password
   * @returns {Promise} - API response
   */
  confirmPasswordReset: async (email, token, new_password) => {
    return await apiService.post('/password-reset-confirm/', {
      email,
      token,
      new_password
    })
  },

  /**
   * Refresh access token
   * @param {string} refresh_token - Refresh token
   * @returns {Promise} - API response with new tokens
   */
  refreshToken: async (refresh_token) => {
    return await apiService.post('/token/refresh/', { refresh: refresh_token })
  },

  /**
   * Get current user account info
   * @returns {Promise} - API response with user account data
   */
  getAccountInfo: async () => {
    return await apiService.get('/account-info/')
  },

  /**
   * Get list of countries for registration
   * @returns {Promise} - API response with countries
   */
  getCountries: async () => {
    return await apiService.get('/countries/')
  },

  /**
   * Accept invitation using token
   * @param {string} token - Invitation token
   * @returns {Promise} - API response
   */
  acceptInvitation: async (token) => {
    return await apiService.post('/accept-invitation/', { token })
  },
}
